import type { SVGProps } from "react";

export const Forkable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 60 60"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Forkable</title>{" "}
    <g transform="translate(0, 18)">
      {" "}
      <path
        d="M24 8.8418L60 5.14258V18.8564L24 15.1572V24H0L0 20.5713H20.5713L20.5713 3.42871L0 3.42871L0 0L24 0V8.8418ZM15.4287 17.1426H0L0 13.7139H15.4287L15.4287 17.1426ZM27.4287 11.9502V12.0498L56.5713 14.666V9.33301L27.4287 11.9502ZM15.4287 10.2861H0L0 6.85742H15.4287V10.2861Z"
        fill="currentColor"
      />{" "}
    </g>
  </svg>
);

export default Forkable;
